/* eslint-disable react/prop-types */
const Button1 = ({ title }) => {
  return (
    <button className="px-6 py-3 bg-transparent hover:bg-prime-red hover:text-white hover:-translate-y-2 hover:border hover:border-prime-red transition2 border rounded-full cursor-pointer z-[99999]">
      {title}
    </button>
  );
};

export default Button1;
